import dayjs from "dayjs";
import { Form, Formik } from "formik";
import React, { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "@/redux/types";

import { Button } from "@/components/ui/Button";
import {
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/Dialog";

import { OpportunityContext } from "../constants";
import { setIsCompletedDialogOpen } from "../stageAndStatusPopoverForCandidateOpportunitiesSlice";
import EventDateTimeField from "./EventDateTimeField";

type Props = {
  handleCompletedSubmit: (values: { event_time: string }) => void;
};

const CompletedStatusDialog = ({ handleCompletedSubmit }: Props) => {
  const opportunity = useContext(OpportunityContext);
  const dispatch = useDispatch();

  const dialogState = useSelector(
    (state: RootState) =>
      state.stageAndStatusPopoverForCandidateOpportunitiesSlice
        .isCompletedDialogOpen,
  );

  const isOpen =
    dialogState?.id === opportunity?.job_id &&
    dialogState?.candidate_id === opportunity?.candidate_id &&
    dialogState?.open;

  const handleClose = () => {
    if (!dialogState?.id) return;

    dispatch(
      setIsCompletedDialogOpen({
        id: dialogState.id,
        open: false,
        candidate_id: dialogState.candidate_id,
      }),
    );
  };

  const handleSubmit = (values: { event_time: string }) => {
    handleCompletedSubmit(values);
    handleClose();
  };

  if (!isOpen) return null;

  return (
    <Dialog isOpen={isOpen} className="w-[600px]">
      <DialogHeader>
        <DialogTitle>Mark as Completed</DialogTitle>
      </DialogHeader>

      <Formik
        initialValues={{
          event_time: dayjs().toISOString(),
        }}
        onSubmit={handleSubmit}
      >
        <Form>
          <DialogBody>
            <EventDateTimeField
              name="event_time"
              helperText="Select when the event was completed (defaults to now)"
            />
          </DialogBody>

          <DialogFooter>
            <Button variant="tertiary" onClick={handleClose}>
              Cancel
            </Button>
            <Button type="submit">Submit</Button>
          </DialogFooter>
        </Form>
      </Formik>
    </Dialog>
  );
};

export default CompletedStatusDialog;
